import useMediaQuery from '@cash-web/shared-ui-use-media-query'
import { usePreference } from '@cash-web/shared-ui-use-preference'

export const useDarkMode = () => {
  const prefersDarkMode = useMediaQuery('@media(prefers-color-scheme: dark)')
  const [preference] = usePreference('darkMode')

  return preference === 'on' || (prefersDarkMode && preference === 'auto')
}
